import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyC7IST8gjCGXr5_EE6WJL0-HiN1EHDmW7w",
    authDomain: "biyerjuti-95738.firebaseapp.com",
    projectId: "biyerjuti-95738",
    storageBucket: "biyerjuti-95738.firebasestorage.app",
    messagingSenderId: "489064701869",
    appId: "1:489064701869:web:20f463521127f9a5398b24",
    measurementId: "G-6Y4CXF91BV"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
const messaging = getMessaging(firebaseApp);

export const requestNotificationPermission = async () => {
    try {
        const permission = await Notification.requestPermission();
        
        if (permission !== 'granted') {
            console.log('Notification permission denied');
            return null;
        }
        
        const token = await getToken(messaging, { 
            vapidKey: "BHgwTGgpNmG9IIYYbK4OdgQB5s1jbRdnBjYhqIrLrrBzyqzMmP-VZe9LJloLeqF2SK5TLEiP5ShdjSYTmMwiVEg" 
        });
        console.log("Firebase Notification Token:", token);
        return token;
    } catch (error) {
        console.error("Error requesting notification permission:", error);
        return null;
    }
};

// Listen for messages when the app is in the foreground
export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
        resolve(payload);
    });
});

export default firebaseApp;
